import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

/**
 * Store the language Django uses for URLs without a language prefix: the `/`
 * redirect, basket, checkout and account. It is written in the browser because
 * a `Set-Cookie` response header would make the page uncacheable.
 */
export const rememberLanguage = (languageCode: string): void => {
    const doc = getDocument();
    if (doc) {
        doc.cookie = `django_language=${encodeURIComponent(languageCode)}; path=/; max-age=31536000; samesite=lax`;
    }
};

/**
 * Pages whose URL carries a language set it as the remembered language, so the
 * unprefixed pages follow the language the visitor was last reading.
 */
export const rememberPageLanguage = (
    path: string,
    languageCode: string,
): void => {
    if (path.startsWith(`/${languageCode}/`)) {
        rememberLanguage(languageCode);
    }
};
